// Ship From Locations: the addresses labels ship from, then which address and
// sender name each connected store uses (ShipStation Ship From Locations parity).
import { ShipFromAddressesSection } from './ShipFromAddressesSection'
import { StoreShipFromSection } from './StoreShipFromSection'
import { useT } from '../../../i18n'
import { shipFromLocationsI18n } from '../../../i18n/admin/ship-from-locations'

function SectionHeading({ id, title, hint }: { id: string; title: string; hint: string }) {
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <h2 id={id} className="text-base font-semibold text-[var(--color-text)]">
        {title}
      </h2>
      <span className="text-xs text-[var(--color-text-muted)]">{hint}</span>
    </div>
  )
}

export function ShipFromLocationsPage() {
  const t = useT(shipFromLocationsI18n).page
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-[var(--color-text)]">{t.title}</h1>
        <p className="mt-0.5 max-w-3xl text-sm text-[var(--color-text-muted)]">
          {t.description}
        </p>
      </div>

      <section aria-labelledby="sf-addresses-heading" className="space-y-3">
        <SectionHeading id="sf-addresses-heading" title={t.addressesTitle} hint={t.addressesHint} />
        <ShipFromAddressesSection />
      </section>

      <section aria-labelledby="sf-stores-heading" className="space-y-3">
        <SectionHeading id="sf-stores-heading" title={t.storesTitle} hint={t.storesHint} />
        <StoreShipFromSection />
      </section>
    </div>
  )
}
